module.exports = __webpack_public_path__ + "static/img/no_track_icon.97a15194.png";